import { Directive, ElementRef, HostListener, Optional, Self } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appCapitalizeFirstLetter]',
  standalone: true
})
export class CapitalizeFirstLetterDirective {

  constructor(
    private _el: ElementRef<HTMLInputElement>,
    @Optional() @Self() private _ngControl?: NgControl
  ) { }

  @HostListener('input')
  onInput(): void {
    const cursorPosition = this._el.nativeElement.selectionStart || 0;
    if (cursorPosition <= 1) {
      this.capitalize(true);
    }
  }

  @HostListener('blur')
  onBlur(): void {
    this.capitalize(false);
  }

  private capitalize(restoreCursor: boolean): void {
    const input = this._el.nativeElement;
    const value = input.value;

    if (value && value.length > 0) {
      const firstChar = value.charAt(0);

      if (firstChar !== firstChar.toUpperCase()) {
        const cursorPosition = input.selectionStart || 0;
        const capitalizedValue = firstChar.toUpperCase() + value.slice(1);

        if (this._ngControl?.control) {
          this._ngControl.control.setValue(capitalizedValue, { emitEvent: false });
        } else {
          input.value = capitalizedValue;
          input.dispatchEvent(new Event('input', { bubbles: true }));
        }

        if (restoreCursor) {
          setTimeout(() => {
            const newPosition = cursorPosition === 0 ? 1 : cursorPosition;
            input.setSelectionRange(newPosition, newPosition);
          }, 0);
        }
      }
    }
  }
}